var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisabledPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-docs-icon-disabled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M77.6404 2.14671H39.5674V50.3357H77.6404V2.14671Z",
    fill: "#F2F4F5",
    stroke: "#DEE1E4",
    strokeWidth: 2.75891
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M70.2263 6.85558H32.1533V55.0446H70.2263V6.85558Z",
    fill: "#F2F4F5",
    stroke: "#DEE1E4",
    strokeWidth: 2.75891
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M63.0544 12.3751H24.9814V60.5641H63.0544V12.3751Z",
    fill: "#F2F4F5",
    stroke: "#DEE1E4",
    strokeWidth: 2.75891
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M55.3318 18.26H17.2588V66.449H55.3318V18.26Z",
    fill: "#F2F4F5",
    stroke: "#DEE1E4",
    strokeWidth: 2.75891
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M48.1599 23.7794H10.0869V71.9684H48.1599V23.7794Z",
    fill: "#F2F4F5",
    stroke: "#DEE1E4",
    strokeWidth: 2.75891
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M40.4334 29.6643H2.36035V77.8533H40.4334V29.6643Z",
    fill: "#F2F4F5",
    stroke: "#DEE1E4",
    strokeWidth: 2.75891
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledPlaceholder);
export default __webpack_public_path__ + "static/media/disabledPlaceholder.9e241c4c7e809e326d27dee1cf4cf19c.svg";
export { ForwardRef as ReactComponent };